export default __webpack_public_path__ + "static/media/btse.3e61be90.svg";